/**
 * Amount financed for payment estimates after customer down selection.
 * When min_down_payment_reduces_principal is false (e.g. RDL), min_down_payment_amount is
 * required out-of-pocket that does not reduce principal; only the overage reduces financed amount.
 */
export type TierDownPaymentFlags = {
  min_down_payment_reduces_principal?: boolean | null;
  min_down_payment_amount?: number | null;
};

export function financedPrincipalForPayment(
  principal: number,
  effectiveDown: number,
  tier: TierDownPaymentFlags | null | undefined
): number {
  if (!principal || principal <= 0) return 0;
  const reduces = tier?.min_down_payment_reduces_principal !== false;
  if (reduces) {
    return Math.max(0, principal - effectiveDown);
  }
  const floor = tier?.min_down_payment_amount != null ? Number(tier.min_down_payment_amount) : 0;
  const trueDown = Math.max(0, effectiveDown - floor);
  return Math.max(0, principal - trueDown);
}
